import React from 'react';
import styles from "./Cadastro.css";
import Header from "../../components/features/login/Header";
import Circle from "../../components/features/login/Circle";
import TitleModule from '../../components/features/register/TitleModule';
import RegisterProgress from '../../components/features/register/RegisterProgress';
import FormComponent from "../../components/features/register/RegisterForm";

const Cadastro = () => {
    return (
      <div className="Cadastro-Page"> 
        <div className={styles.container}>
            <Header/>
            <RegisterProgress step={1} title="Realize o Cadastro" icon="person"/>
            <FormComponent/>
            <Circle/>
            <TitleModule/>
        </div>
      </div>
    );
  };
  
  export default Cadastro;
  